import styled from 'styled-components';
import { Base } from 'styled';

type DropdownProps = {
  hideDropdown: boolean;
};

export const Container = styled(Base)``;

export const ButtonInner = styled(Base)`
  display: flex;
  justify-content: center;

  img {
    width: 1.041875rem;
    margin-right: 0.75rem;
  }
`;

export const ButtonLabel = styled.span`
  ${({ theme }) => theme.typography.variants.primary.xs};
  color: ${({ theme }) => theme.colors.blue};
`;

export const Dropdown = styled(Base)<DropdownProps>`
  background-color: ${({ theme }) => theme.colors.white};
  ${({ theme }) => theme.transitions['transition-short']};
  border-radius: 0.25rem;
  box-shadow: 0px 0px 15px -5px rgba(0, 0, 0, 0.45);
  opacity: ${({ hideDropdown }) => (hideDropdown ? 0 : 1)};
  pointer-events: ${({ hideDropdown }) => (hideDropdown ? 'none' : 'auto')};
`;

export const DropdownIconContainer = styled(Base)`
  width: 2.25rem;
  display: flex;
  justify-content: flex-start;
`;

export const FacebookShareButton = styled(Base)`
  display: flex;
  align-items: center;
  margin-bottom: 1.5rem;

  img {
    width: 0.471875rem;
  }
`;

export const CopyButton = styled(Base)`
  img {
    width: 0.9375rem;
  }
`;
